import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";

const SortableListRow = ({
  classes,
  children,
  striped,
  selected,
  onClick,
  to,
  noborder,
  noheader,
  Icon,
  StatusIcon = null,
  Action,
  component,
  ...rest
}) => (
  <Grid
    container
    wrap="nowrap"
    alignItems="center"
    className={classNames(classes.root, {
      [classes.rootSelected]: selected,
      [classes.rootStriped]: striped,
      [classes.rootClickable]: onClick || to,
      [classes.rootBorder]: !noborder,
      [classes.rootTopBorder]: !noborder && noheader,
    })}
    {...rest}
  >
    {Icon}
    <Grid
      to={to}
      container
      onClick={onClick}
      alignItems="center"
      component={component}
      className={classes.root}
    >
      {children}
    </Grid>
    {StatusIcon}
    {Action}
  </Grid>
);

SortableListRow.defaultProps = {
  striped: true,
};

const styles = theme => ({
  root: {
    textAlign: "start",
    overflow: "hidden",
    height: theme.altus.largeRow.height,
    backgroundClip: "padding-box",
  },
  rootStriped: {
    "&:nth-child(even)": {
      backgroundColor: theme.palette.grey[200],
    },
  },
  rootSelected: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    "&:nth-child(even)$rootStriped": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  rootClickable: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: `${blue[100]}42`,
    },
    "& $rootStriped:hover": {
      backgroundColor: `${blue[100]}42`,
    },
  },
  rootBorder: {
    borderColor: theme.palette.grey[300],
    borderWidth: 1,
    borderStyle: "none solid solid solid",
  },
  rootTopBorder: {
    "&:first-child": {
      borderTopStyle: "solid",
    },
  },
});

export default compose(withStyles(styles))(SortableListRow);
